export class PhysicianSearchResult {
    public lastName: string;
    public firstName: string;
    public physicianId: number;
    public stateCode: string;
    public fullName: string;
}

export class EvaluatorSearchDto {
    certifiedOn: string;
    name: string;
    certificationIds: Array<number>;
}